import {isVaild} from "@/utils/validate"
import config from "@/utils/config";

export function getDisplayName(user) {
    var res = ""
    if (isVaild(user.Nickname || user.nickname)) {
        res = user.Nickname || user.nickname
    } else if (isVaild(user.FirstName || user.firstName) || isVaild(user.LastName || user.lastName)) {
        res = (user.FirstName || user.firstName) + (user.LastName || user.lastName)
    }
    return res
}

export function getUserType() {
    // console.log("get user type " + config.SHOW_USER_DATA_TYPE)
    if (config.SHOW_USER_DATA_TYPE === 'true') {
        return Object.freeze(
            [
                {
                    name: "医用",
                    value: 0
                },
                {
                    name: "射线DR",
                    value: 1
                },
                {
                    name: "医用&DR",
                    value: 2
                },
            ])
    } else {
        return []
    }

}